import { render, staticRenderFns } from "./ScrollPanel.vue?vue&type=template&id=30bba580&scoped=true&"
import script from "./ScrollPanel.vue?vue&type=script&lang=ts&"
export * from "./ScrollPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollPanel.vue?vue&type=style&index=0&id=30bba580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bba580",
  null
  
)

export default component.exports